import { render, staticRenderFns } from "./PersistableItem.vue?vue&type=template&id=35f8ffac&scoped=true&"
import script from "./PersistableItem.vue?vue&type=script&lang=ts&"
export * from "./PersistableItem.vue?vue&type=script&lang=ts&"
import style0 from "./PersistableItem.vue?vue&type=style&index=0&id=35f8ffac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f8ffac",
  null
  
)

export default component.exports